import React from "react";
import PropTypes from "prop-types";
import { toPairs, values } from "lodash";
import { useTranslate } from "@tolgee/react";
import numericalFieldHandler from "../../../utils/numericalFieldHandler";
import translateLabel from "../../../utils/translateLabel";

const RepeatWeekly = ({
  id,
  weekly: { interval, days, options },
  handleChange,
  translations,
}) => {
  const { t } = useTranslate();
  let daysArray = toPairs(days);
  if (options.weekStartsOnSunday) {
    daysArray = daysArray.slice(-1).concat(daysArray.slice(0, -1));
  }
  const noDaySelected = values(days).every((isActive) => !isActive);

  return (
    <div className="w-100 d-flex flex-column gap-2">
      <div className="form-group d-flex gap-4 align-items-sm-center">
        <div className="">
          {translateLabel(translations, "repeat.weekly.every")}
        </div>
        <div className="">
          <input
            id={`${id}-interval`}
            name="repeat.weekly.interval"
            aria-label="Repeat weekly interval"
            className="form-control"
            value={interval}
            onChange={numericalFieldHandler(handleChange)}
          />
        </div>
        <div className="">
          {translateLabel(translations, "repeat.weekly.weeks")}
        </div>
      </div>

      <div className="form-group w-100 d-flex flex-column gap-1 flex-fill">
        <div className="btn-group btn-group-toggle d-flex flex-wrap w-100 justify-content-center">
          {daysArray.map(([dayName, isDayActive]) => (
            <label
              htmlFor={`${id}-${dayName}`}
              key={dayName}
              className={`btn btn-sm rounded-0 px-1 ${
                isDayActive ? "active btn-primary" : "btn-secondary"
              }`}
              style={{ width: "2rem" }}
            >
              <input
                type="radio"
                id={`${id}-${dayName}`}
                name={`repeat.weekly.days[${dayName}]`}
                className="form-control btn-check "
                checked={isDayActive}
                autoComplete="off"
                onClick={(event) => {
                  const editedEvent = {
                    ...event,
                    target: {
                      ...event.target,
                      value: !isDayActive,
                      name: event.target.name,
                    },
                  };
                  handleChange(editedEvent);
                }}
                readOnly
              />
              {translateLabel(
                translations,
                `days_short.${dayName.toLowerCase()}`
              )}
            </label>
          ))}
        </div>
        {noDaySelected && (
          <div className="text-danger small mt-1" role="alert">
            {t("lomavisCreator.recurrence.weekly.no_day_warning")}
          </div>
        )}
      </div>
    </div>
  );
};

RepeatWeekly.propTypes = {
  id: PropTypes.string.isRequired,
  weekly: PropTypes.shape({
    interval: PropTypes.number.isRequired,
    days: PropTypes.shape({
      mon: PropTypes.bool.isRequired,
      tue: PropTypes.bool.isRequired,
      wed: PropTypes.bool.isRequired,
      thu: PropTypes.bool.isRequired,
      fri: PropTypes.bool.isRequired,
      sat: PropTypes.bool.isRequired,
      sun: PropTypes.bool.isRequired,
    }).isRequired,
    options: PropTypes.shape({
      weekStartsOnSunday: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  translations: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
    .isRequired,
};

export default RepeatWeekly;
